module.exports = __webpack_public_path__ + "img/default.ee0542cc.png";